import React, { useMemo } from 'react';
import { Form, Radio } from 'tea-component';
import { useIntl } from 'umi';
import { GptOptionsType } from '../../types';
import BubbleCommon, { aigcAdvancedSummaryTips } from '@op/components/BubbleCommon';
import useLanguage from '@op/hooks/useLanguage';

export type SummaryModeFormProps = {
  gptOptions: GptOptionsType;
  setGptOptions: (value: GptOptionsType) => void;
  remainder: number;
  total: number;
  advancedLimitLoading: boolean;
};

export default function SummaryModeForm({
  gptOptions,
  setGptOptions,
  remainder,
  total,
  advancedLimitLoading,
}: SummaryModeFormProps) {
  const { formatMessage } = useLanguage();

  const [tipsMap, disabled] = useMemo(() => {
    const hasRemainder = remainder > 0 || remainder === -1;
    const disabled = !hasRemainder || advancedLimitLoading;
    const tipsMap = aigcAdvancedSummaryTips(total);

    return [tipsMap, disabled];
  }, [advancedLimitLoading, total]);


  return (
    <Form.Item label={formatMessage({ id: 'Summary Mode' })}>
      <Radio.Group
        value={gptOptions}
        onChange={(value: any) => {
          if (value === 'advanced' && advancedLimitLoading && remainder === 0) {
            return;
          }
          setGptOptions(value);
        }}
        className="dbo-summary-mode-group"
      >
        <Radio
          name="advanced"
          className={`dbo-summary-mode-pill ${gptOptions === 'advanced' ? 'dbo-summary-mode-pill--active' : ''}`}
          disabled={disabled}
        >
          <BubbleCommon showIcon={false} placement="top" tipsMap={tipsMap}>
            <span>{formatMessage({ id: 'Advanced Quantitative Summary' })}</span>
            {remainder !== -1 && (
              <span className="dbo-summary-mode-remainder">
                {formatMessage(
                  { id: '(Remaining system uses today: {remainder}/{total})' },
                  {
                    remainder: (
                      <i style={{ color: remainder > 0 ? '#29B569' : '#EF5858' }}>
                        {remainder}
                      </i>
                    ),
                    total,
                  },
                )}
              </span>
            )}
          </BubbleCommon>
        </Radio>
        <Radio
          name="basic"
          className={`dbo-summary-mode-pill ${gptOptions === 'basic' ? 'dbo-summary-mode-pill--active' : ''}`}
        >
          <span>{formatMessage({ id: 'Quick' })}</span>
          <span className="dbo-summary-mode-time">{formatMessage({ id: '(<1 min)' })}</span>
        </Radio>
      </Radio.Group>
      <div className="dbo-summary-mode-desc">
        {formatMessage({ id: gptOptions === 'advanced' ? 'Advanced quantitative — AI captures more opinions and quantifies each precisely.' : 'Quick — faster, with fewer opinions and rougher numbers.' })}
      </div>
    </Form.Item>
  );
}
